<template>
  <div class="page-content blacklist">
    <div class="row">
      <div class="col-sm-6 col-12">
        <lookup-carrier />
        <identify-information />
      </div>
      <div class="col-sm-6 col-12">
        <request-to-blacklist-caller />
      </div>

      <div class="col-12">
        <search-black-list />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const LookupCarrier = defineAsyncComponent(() => import('./Blacklist/LookupCarrier.vue') as any);

const RequestToBlacklistCaller = defineAsyncComponent(() => import('./Blacklist/RequestToBlacklistCaller.vue') as any);

const SearchBlackList = defineAsyncComponent(() => import('./Blacklist/SearchBlackList.vue') as any);

const IdentifyInformation = defineAsyncComponent(() => import('./Blacklist/IdentifyInformation.vue') as any);

onMounted(async () => {
  const route = useRoute();
  await nextTick();
  util.moveScrollComponent(route.hash);
});
</script>
